// extracted by mini-css-extract-plugin
export default {"dot":"NotificationDot_dot__DIGNE"};